import React from "react";

/* Import Boostrap */
import { Row, Col } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import VisibilitySensor from 'react-visibility-sensor';

import Heading2 from './Heading2';
import Paragraph from '../paragraphs/Paragraph';

class Heading2Paragraph extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            animated : false,
            animationClasses : ['text-center', 'gtco-heading'],
        };
        this.headerVisible = this.headerVisible.bind(this);
    }

    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var classes = this.state.animationClasses;
                classes.push('fadeInUp');
                classes.push('animated-fast');
                this.setState({ animated: true, animationClasses: classes });
            }
        }
    };

    render () {
        return (
            <Row>
                <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible }>
                    <Col className={ this.state.animationClasses.join(' ') } style={ { opacity : 0 } } md={8} mdOffset={2}>
                        <Heading2 title={ this.props.content.title } />
                        <Paragraph text={ this.props.content.paragraph } />
                    </Col>
                </VisibilitySensor>
            </Row>
        );
    };
};

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(Heading2Paragraph);


// WEBPACK FOOTER //
// ./src/components/titles/heading2-paragraph.js